import { UNUSED_PARAMETER } from 'hooks/metrics/shared/constants';
import { CONTENT_TYPE, CONTENT_CATEGORY } from '../constants';

/**
 * Defaults de los campos item_* para el evento view_item.
 *
 * - item_category  = 'mundial'  (espejo de CONTENT_TYPE)
 * - item_category2 = 'deportes' (espejo de CONTENT_CATEGORY)
 * - El resto va como UNUSED_PARAMETER ("no aplica").
 */
export const buildViewItemDefaults = () => ({
  item_id: UNUSED_PARAMETER,
  item_name: UNUSED_PARAMETER,
  item_brand: UNUSED_PARAMETER,
  item_category: CONTENT_TYPE,
  item_category2: CONTENT_CATEGORY,
  item_category3: UNUSED_PARAMETER,
  item_category4: UNUSED_PARAMETER,
  item_variant: UNUSED_PARAMETER,
  item_list_name: UNUSED_PARAMETER,
  index: UNUSED_PARAMETER,
  price: UNUSED_PARAMETER,
  item_stats_detail: UNUSED_PARAMETER,
  visible_content_id: UNUSED_PARAMETER,
});
